import { objectRemoveKey } from "@syla/shared/helpers/objectRemoveKey";
import { CreateStripeBillingPortalRequestBody } from "@syla/shared/types/requests/CreateStripeBillingPortalRequest";
import { useMutation } from "react-query";
import { createStripeBillingPortalSession } from "../api/plans/createStripeBillingPortalSession";

export const useMutationCreateStripeBillingPortalSession = () =>
  useMutation(
    ["create-stripe-billing-portal-session"],
    (props: CreateStripeBillingPortalRequestBody & { accountId: string }) =>
      createStripeBillingPortalSession(
        props.accountId,
        objectRemoveKey(
          props,
          "accountId",
        ) as CreateStripeBillingPortalRequestBody,
      ),
  );
